import { useEffect } from 'react';
import { getMetrikaConfig } from '@/components/analytics/YandexMetrika.config';
import { YandexMetrikaModeIF } from '@/declarations/window';

export const YandexMetrika = (): null => {
    useEffect(() => {
        const { enabled, id, options } = getMetrikaConfig();

        if (!enabled || !id || window.ym) {
            return;
        }

        const counterId = Number(id);
        const ymQueue: unknown[][] = [];

        const ymStub = (...arguments_: unknown[]): void => {
            ymQueue.push(arguments_);
        };

        window.ym = ymStub as YandexMetrikaModeIF;

        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://mc.yandex.ru/metrika/tag.js';

        script.addEventListener('load', () => {
            window.ym?.(counterId, 'init', options);
            ymQueue.forEach((arguments_) =>
                window.ym?.(...(arguments_ as Parameters<YandexMetrikaModeIF>)),
            );
        });

        document.head.append(script);
    }, []);

    return null;
};
